/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateMapStateResponse } from '../models/CreateMapStateResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MapStateControllerService {
    /**
     * @param propertyId
     * @param context
     * @returns void
     * @throws ApiError
     */
    public static mapStateControllerClearMapState(
        propertyId: string,
        context?: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/map-state/{propertyId}',
            path: {
                'propertyId': propertyId,
            },
            query: {
                'context': context,
            },
        });
    }
    /**
     * @param propertyId
     * @param context
     * @returns any Return value of MapStateController.getMapState
     * @throws ApiError
     */
    public static mapStateControllerGetMapState(
        propertyId: string,
        context?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/map-states/{propertyId}',
            path: {
                'propertyId': propertyId,
            },
            query: {
                'context': context,
            },
        });
    }
    /**
     * @param requestBody Create a new MapState entry
     * @param propertyId
     * @param tenantId
     * @param context
     * @returns CreateMapStateResponse Response after creating a MapState entry
     * @throws ApiError
     */
    public static mapStateControllerCreateMapState(
        requestBody: {
            /**
             * Array of pin objects representing markers on the map
             */
            pins?: Array<Record<string, any>>;
            /**
             * Array of objects representing items dropped on the map
             */
            droppedItems?: Array<Record<string, any>>;
            /**
             * Array of points defining the site plan
             */
            sitePlanPoints?: Array<Record<string, any>>;
            /**
             * Array of coordinates defining custom map points
             */
            mapPoints?: Array<Record<string, any>>;
            /**
             * Type of state - map or siteplan
             */
            context?: 'map' | 'siteplan';
        },
        propertyId?: string,
        tenantId?: string,
        context?: string,
    ): CancelablePromise<CreateMapStateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/map-states',
            query: {
                'propertyId': propertyId,
                'tenantId': tenantId,
                'context': context,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
